const Amforc = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.12 94.24">
    <defs>
      <linearGradient
        id="a"
        x1="46.57"
        y1="97.04"
        x2="47.53"
        y2="2.32"
        gradientTransform="matrix(1 0 0 -1 0 96.38)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#507e99" />
        <stop offset=".78" stopColor="#8fd698" />
        <stop offset="1" stopColor="#aad4a0" />
      </linearGradient>
    </defs>
    <path
      d="M77.22 94.11H16.89A16.89 16.89 0 010 77.22V16.89A16.89 16.89 0 0116.89 0h60.33a16.89 16.89 0 0116.89 16.89v60.33a16.89 16.89 0 01-16.89 16.89z"
      fill="#1d5c81"
    />
    <path
      d="M91.09 86.85L60 10.16l-34 84h4.91l29-72.41 27.25 69.11a17 17 0 003.93-4.01z"
      fill="#8fd698"
    />
    <path fill="#3a8286" d="M20.53 39.49h41.9v4.27h-41.9z" />
    <path fill="#8fd698" d="M38.94 63.06h41.93v4.33H38.94z" />
    <path
      fill="#3a8286"
      d="M31.6 51.41h41.89v4.36H31.6zM63.12 57.09h30.99v4.45H63.12z"
    />
    <path fill="#8fd698" d="M5.72 45.46h35.6v4.36H5.72z" />
    <path
      d="M77.22 94.11H16.89A16.89 16.89 0 010 77.22V16.89A16.89 16.89 0 0116.89 0h60.33a16.89 16.89 0 0116.89 16.89v60.33a16.89 16.89 0 01-16.89 16.89z"
      fill="url(#a)"
    />
    <path
      d="M60.24 10.74h-.39l-33.8 83.5H31l29-72.41L87.18 91a16.81 16.81 0 003.93-4z"
      fill="#fff"
    />
    <path
      fill="#3a8286"
      d="M12.85 39.49h41.9v4.27h-41.9zM23.93 51.41h41.89v4.36H23.93zM55.45 57.09h38.67v4.45H55.45z"
    />
    <path
      fill="#114a62"
      d="M0 45.46h33.64v4.36H0zM31.26 63.06h41.93v4.33H31.26z"
    />
  </svg>
);

export default Amforc;
